var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChevronArrowLeft = function SvgChevronArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.797 2.5 2.407 19.89 20.02 37.5",
    stroke: "#4F4F4F",
    strokeWidth: 3
  })));
};

export { SvgChevronArrowLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCAyMiA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5Ljc5NjYgMi41TDIuNDA3OTIgMTkuODg5NEwyMC4wMTg2IDM3LjUiIHN0cm9rZT0iIzRGNEY0RiIgc3Ryb2tlLXdpZHRoPSIzIi8+Cjwvc3ZnPgo=";